import React, { useEffect, useState } from "react";

const MESSAGES = [
    "Reviewing your message for tone",
    "Checking how this might come across",
    "Refining your message for clarity",
];

const ROTATE_MS = 2400;

/**
 * AnalyzingIndicator
 *
 * Calm, reassuring placeholder shown while the tone analysis is in flight.
 * - Mirrors the AnalysisCard's vertical footprint so layout doesn't jump
 *   when results arrive.
 * - Cycles through three considered messages with a soft crossfade.
 * - Three faintly pulsing dots animate in sequence (CSS-only).
 */
const AnalyzingIndicator = () => {
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        const id = window.setInterval(() => {
            setIdx((i) => (i + 1) % MESSAGES.length);
        }, ROTATE_MS);
        return () => window.clearInterval(id);
    }, []);

    return (
        <div
            data-testid="analyzing-indicator"
            role="status"
            aria-live="polite"
            className="tg-enter mx-auto w-full bg-card/70 border border-border/70 rounded-2xl p-5 sm:p-6 min-h-[176px] flex flex-col items-start justify-center gap-4"
        >
            <div className="flex items-center gap-3">
                <span className="relative flex h-2.5 w-2.5">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-primary/40 animate-ping" />
                    <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary/70" />
                </span>
                <p
                    data-testid="analyzing-message"
                    key={idx}
                    className="font-serif text-[18px] sm:text-[20px] leading-snug text-foreground/85 tg-fade"
                >
                    {MESSAGES[idx]}
                    <span className="tg-ellipsis ml-0.5" aria-hidden="true">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </span>
                </p>
            </div>

            {/* Layout-stable shimmer block to match the analysis card body */}
            <div className="w-full grid gap-3 sm:grid-cols-2">
                <div className="h-16 rounded-xl border border-border/60 bg-muted/40 relative overflow-hidden">
                    <div className="absolute inset-0 tg-shimmer" />
                </div>
                <div className="h-16 rounded-xl border border-[#D5E3D1]/70 bg-[#EAF1E8]/40 relative overflow-hidden">
                    <div className="absolute inset-0 tg-shimmer" />
                </div>
            </div>
        </div>
    );
};

export default AnalyzingIndicator;
